<app-increment (cambioValor)="progreso = $event" nombre="Progreso Bar NAME"></app-increment>
